module.exports = __webpack_public_path__ + "img/declaration.5be0d337.png";